import React from 'react';

// ZenScroll brand logos — served locally from /public to avoid external-URL
// breakage in preview/production environments.
// Mark = circular brush "ZenScroll" mark, optimized for dark backgrounds.
const LOGO_ICON = '/brand/zenscroll-mark.png';
const LOGO_ICON_ALT = '/assets/splash/zenscroll-logo.png';
const LOGO_FULL = '/brand/zenscroll-mark.png';

export function LogoIcon({ className = "w-8 h-8", alt = false, tint = null }) {
  const src = alt ? LOGO_ICON_ALT : LOGO_ICON;
  // When `tint` is provided (e.g. `#1C4749`), render the PNG as a CSS mask so
  // the visible pixels take on that solid colour. Works because the brand
  // mark PNG has a transparent background — only the mark itself receives
  // the tint. Falls back to the raw `<img>` when no tint is requested.
  if (tint) {
    return (
      <span
        role="img"
        aria-label="ZenScroll"
        // `aspect-square` so the masked span gets a definite width (height
        // classes from `className` drive the size — the logo mark is square).
        className={`inline-block aspect-square ${className}`}
        style={{
          backgroundColor: tint,
          WebkitMaskImage: `url(${src})`,
          maskImage: `url(${src})`,
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
        }}
      />
    );
  }
  return (
    <img
      src={src}
      alt="ZenScroll"
      className={`object-contain ${className}`}
    />
  );
}

export function LogoWithText({ className = "", iconSize = "w-8 h-8", textSize = "text-2xl" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <LogoIcon className={iconSize} />
      <span className={`font-heading font-bold text-foreground ${textSize}`}>
        zenscroll
      </span>
    </div>
  );
}

export function LogoFull({ className = "h-12" }) {
  return (
    <img 
      src={LOGO_FULL} 
      alt="ZenScroll" 
      className={`object-contain ${className}`}
    />
  );
}

export default LogoWithText;
